// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { DownloadRounded } from '@/constants/hardfin-standard-icons';
import { LoadingButton } from '@mui/lab';

interface ReportExportButtonProps {
  label: string;
  isPending: boolean;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Outlined "export to Excel" button shared by the asset report routes. Shows a
 * spinner while the download is pending; disabled while pending or when the
 * caller supplies an additional disabled condition.
 *
 * Built on LoadingButton rather than a Button with a swapped endIcon: it reserves
 * the indicator slot, so the button does not change width when the export starts
 * and jitter the toolbar it sits in, and it carries the busy semantics a screen
 * reader needs to announce more than "disabled".
 */
export function ReportExportButton(props: ReportExportButtonProps) {
  const { label, isPending, onClick, disabled } = props;

  return (
    <LoadingButton
      variant="outlined"
      size="small"
      loading={isPending}
      loadingPosition="end"
      endIcon={<DownloadRounded fontSize="small" />}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </LoadingButton>
  );
}
